import { render, staticRenderFns } from "./ProfilComplementary.vue?vue&type=template&id=6cd11799"
import script from "./ProfilComplementary.vue?vue&type=script&lang=ts"
export * from "./ProfilComplementary.vue?vue&type=script&lang=ts"
import style0 from "./ProfilComplementary.vue?vue&type=style&index=0&id=6cd11799&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports